'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDescription = function getDescription(event) {
  return event.name + ' - ' + getTitle(event);
};

var getTitle = function getTitle(event) {
  var title = '';

  if (event.level) {
    title = event.level + ' ';
  }

  title += (event.adults ? 'Adults' : event.age) + ' ';

  title += event.event;

  return title;
};

var getExpectedScoresheets = function getExpectedScoresheets(eventType) {
  return eventType === 'C' ? 3 : 1;
};

exports.getDescription = getDescription;
exports.getTitle = getTitle;
exports.getExpectedScoresheets = getExpectedScoresheets;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/utilities/events.js
// module id = 94
// module chunks = 0